import Vue from "vue";
import Component from "vue-class-component";

import { IUsers, IUsersItems } from "@/entity/Settings/Users.types";
import { SettingsUsersStore } from "@/store/modules/Settings/User";

@Component
export class UsersSettingsMix extends Vue {
  get user(): IUsersItems | null {
    return SettingsUsersStore.usersItems;
  }
  get users(): IUsers | null {
    return SettingsUsersStore.users;
  }
}
